// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { lifeEnquiryAPI, updateFirstPageData } from '../../Redux/LifeRedux';
// import vector from '../../assets/Vector.png';
// import './filter.css';
// import Dropdown from '../life-dropdown';
// import CustomInputBox from '../selectTextInput';
// import { getAgeOptions } from '../../utilities/dobToCoverTillAge';
// import sumAssuredData from '../../utilities/sumAssuredTemp';
// import formatSumAssured from '../../utilities/calculateSum';
// import { calculateAge } from '../../utilities/calculateAge';
// import AlertLumpsumModal from './../input-alert-lumpsum';

// export const FilterBar = ({
//   CallQuoteAPIs,
//   isCheckedMenu,
//   handleCheckboxChange,
//   slugData,
// }) => {
//   // State for redux and dropdown
//   const combinedRedux = useSelector((state) => state.life.combinedRedux);
//   const Age = calculateAge(combinedRedux?.userDetail?.dob);

//   // section for policy term
//   const policyData = combinedRedux.coverTillAge - Age;
//   const policyTermData = combinedRedux.policyTerm
//     ? combinedRedux.policyTerm
//     : policyData;

//   const annualInc = combinedRedux?.userDetail?.annualIncome;
//   const mainData = combinedRedux?.userDetail?.dob;
//   const dispatch = useDispatch();
//   const [ppt, setPpt] = useState(
//     combinedRedux.premiumPaymentTerm
//       ? combinedRedux.premiumPaymentTerm
//       : policyTermData
//   );
//   const [modeOfPayment, setModeOfPayment] = useState('');
//   const [sumAssured, setSumAssured] = useState('');
//   const [claimSettlementRatio, setClaimSettlementRatio] = useState('');
//   let [coverTillAge, setCoverTillAge] = useState([]);
//   const [deathBenefit, setDeathBenefit] = useState('');
//   const [deathTooltip, setDeathTooltip] = useState('Lump-Sum');
//   const [payoutTooltip, setPayoutTooltip] = useState('payout');
//   const [lumpSumPersent, setLumpSumPersent] = useState('');
//   const [payoutTermState, setPayoutTermState] = useState('');
//   // State variable to track if the alert has been shown
//   const [alertShown, setAlertShown] = useState(false);

//   const [lifeFilter, setLifeFilter] = useState({
//     policyTerm: '',
//     premiumPaymentTerm: '',
//     modeOfPayment: '',
//     sumAssured: '',
//     coverTillAge: '',
//     DeathBenefitOption: '',
//     claimSettlementRatio: '',
//     PremiumPaymentOption: '',
//     LumpsumPercentage: '',
//     PayoutTerm: '',
//   });
//   // const tataSlug = ['tata-mrs', 'tata-life-srp']

//   // dropdown options data
//   const premiumPaymentTermOptions = [
//     'Select',
//     ...Array.from({ length: 26 }, (_, index) => (index + 1).toString()),
//   ];
//   const payModeOptions = [
//     'Select',
//     'Yearly',
//     'Half-Yearly',
//     'Quarterly',
//     'Monthly',
//   ];
//   const deathBenefits = [
//     'Select',
//     'Lump-Sum',
//     'Income',
//     'Increasing Income',
//     'Lump-Sum-Income',
//   ];
//   const premiumPaymentOptions = [
//     'Select',
//     'Regular Pay',
//     'Limited Pay',
//     'Single Pay',
//   ];
//   const payoutTermData = ['Select', '5', '10', '20', '30', '40'];
//   const payoutAllowedOptions = ['Income', 'Lump-Sum-Income'];

//   // for add cover till age

//   // useEffect(() => {
//   //   if (mainData) {
//   //     const options = getAgeOptions(new Date(mainData));
//   //     const updatedOptions = ['Select', 'Whole Life', ...options];
//   //     setCoverTillAge(updatedOptions);

//   //     // Check if the selected value is "Whole Life"
//   //     if (lifeFilter.coverTillAge === 'Whole Life') {
//   //       // Set the value to 100
//   //       setLifeFilter(prevFilter => ({
//   //         ...prevFilter,
//   //         coverTillAge: 99,
//   //       }));
//   //     }
//   //   }
//   // }, [mainData, lifeFilter.coverTillAge]);

//   // for update premiumPaymentOptions automatically
//   useEffect(() => {
//     if (
//       lifeFilter.premiumPaymentTerm !== '' ||
//       lifeFilter.PremiumPaymentOption !== ''
//     ) {
//       // Dispatch the update action with the updated values
//       dispatch(
//         updateFirstPageData({
//           premiumPaymentTerm: lifeFilter.premiumPaymentTerm,
//           PremiumPaymentOption: lifeFilter.PremiumPaymentOption,
//           enquiryId: combinedRedux.enquiryId,
//         })
//       )
//         .then(() => {
//           dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//           CallQuoteAPIs();
//         })
//         .catch((error) => {
//           console.error('Error updating database:', error);
//         });
//     }
//   }, [lifeFilter.premiumPaymentTerm, lifeFilter.PremiumPaymentOption]);

//   // for updating Cover Till Age
//   useEffect(() => {
//     if (mainData) {
//       const options = getAgeOptions(new Date(mainData));
//       const updatedOptions = ['Select', 'Whole Life', ...options];
//       setCoverTillAge(updatedOptions);

//       // Check if the selected value is "Whole Life"
//       if (lifeFilter.coverTillAge === 'Whole Life') {
//         // Set the value to 100
//         setLifeFilter((prevFilter) => ({
//           ...prevFilter,
//           coverTillAge: 99,
//         }));
//       } else if (lifeFilter.coverTillAge !== '') {
//         // Add an else condition here
//         dispatch(
//           updateFirstPageData({
//             coverTillAge: lifeFilter.coverTillAge,
//             premiumPaymentTerm: policyTermData,
//             enquiryId: combinedRedux.enquiryId,
//           })
//         )
//           .then(() => {
//             dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//             CallQuoteAPIs();
//           })
//           .catch((error) => {
//             console.error('Error updating coverTillAge:', error);
//           });
//       }
//     }
//   }, [lifeFilter.coverTillAge, mainData]);

//   // for  updating Sum Assured
//   useEffect(() => {
//     if (lifeFilter.sumAssured != '') {
//       dispatch(
//         updateFirstPageData({
//           sumAssured: lifeFilter.sumAssured,
//           enquiryId: combinedRedux.enquiryId,
//         })
//       )
//         .then(() => {
//           dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//           CallQuoteAPIs();
//         })
//         .catch((error) => {
//           console.error('Error updating sumAssured:', error);
//         });
//     }
//   }, [lifeFilter.sumAssured]);

//   // for updating Mode of payment
//   useEffect(() => {
//     if (lifeFilter.modeOfPayment != '') {
//       dispatch(
//         updateFirstPageData({
//           modeOfPayment: lifeFilter.modeOfPayment,
//           enquiryId: combinedRedux.enquiryId,
//         })
//       )
//         .then(() => {
//           dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//           CallQuoteAPIs();
//         })
//         .catch((error) => {
//           console.error('Error updating modeOfPayment:', error);
//         });
//     }
//   }, [lifeFilter.modeOfPayment]);

//   // for DeathBenefitOption
//   useEffect(() => {
//     if (lifeFilter.DeathBenefitOption != '') {
//       dispatch(
//         updateFirstPageData({
//           DeathBenefitOption: lifeFilter.DeathBenefitOption,
//           enquiryId: combinedRedux.enquiryId,
//         })
//       )
//         .then(() => {
//           dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//           CallQuoteAPIs();
//         })
//         .catch((error) => {
//           console.error('Error updating DeathBenefitOption:', error);
//         });
//     }
//     if (lifeFilter.DeathBenefitOption === 'Income') {
//       setDeathTooltip('Income');
//     } else if (lifeFilter.DeathBenefitOption === 'Lump-Sum') {
//       setDeathTooltip('Lump-Sum');
//     }
//   }, [lifeFilter.DeathBenefitOption]);

//   // useEffect (() => {
//   //     if(lifeFilter.LumpsumPercentage != "") {
//   //         dispatch(updateFirstPageData({LumpsumPercentage: lifeFilter.LumpsumPercentage, enquiryId: combinedRedux.enquiryId})).then(()=>{
//   //             dispatch(lifeEnquiryAPI({enquiryId: combinedRedux.enquiryId}))
//   //             CallQuoteAPIs()
//   //         }).catch((error) => {
//   //             console.error("Error updating LumpsumPercentage:", error);
//   //         });
//   //     }
//   // }, [lifeFilter.LumpsumPercentage]);

//   useEffect(() => {
//     if (lifeFilter.PayoutTerm != '') {
//       dispatch(
//         updateFirstPageData({
//           PayoutTerm: lifeFilter.PayoutTerm,
//           enquiryId: combinedRedux.enquiryId,
//         })
//       )
//         .then(() => {
//           dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
//           CallQuoteAPIs();
//         })
//         .catch((error) => {
//           console.error('Error updating payoutTerm:', error);
//         });
//     }
//   }, [lifeFilter.PayoutTerm]);

//   // const handleLumpSumPersent = (value) => {
//   //     if (value > 100) {
//   //         setLumpSumPersent(100);
//   //         setLifeFilter({ ...lifeFilter, LumpsumPercentage: 100 });
//   //     } else if(value != "") {
//   //         setLumpSumPersent(value);
//   //         setLifeFilter({ ...lifeFilter, LumpsumPercentage: value });
//   //     }
//   // }

//   // for handle ppt change with condition PPt should not be greater than policy term
//   const handlePpt = (value) => {
//     if (value !== '') {
//       let policyTerm = combinedRedux.policyTerm
//         ? combinedRedux.policyTerm
//         : policyTermData;
//       if (Number(value) >= policyTerm) {
//         setPpt(policyTerm);
//         setLifeFilter({
//           ...lifeFilter,
//           premiumPaymentTerm: policyTerm,
//           PremiumPaymentOption: 'Regular Pay',
//         });
//       } else if (Number(value) === 1) {
//         setPpt(value);
//         setLifeFilter({
//           ...lifeFilter,
//           premiumPaymentTerm: value,
//           PremiumPaymentOption: 'Single Pay',
//         });
//       } else {
//         setPpt(value);
//         setLifeFilter({
//           ...lifeFilter,
//           premiumPaymentTerm: value,
//           PremiumPaymentOption: 'Limited Pay',
//         });
//       }
//     }
//   };

//   const handleSumAssured = (value) => {
//     if (value > 1000000000) {
//       setSumAssured(1000000000);
//       setLifeFilter({ ...lifeFilter, sumAssured: 1000000000 });
//     } else if (value != '') {
//       setSumAssured(value);
//       setLifeFilter({ ...lifeFilter, sumAssured: value });
//     }
//   };

//   // sum assured calculation
//   // let data = [];
//   // const sumAssuredOptions = [
//   // 'Select',
//   // ...Array.from({ length: 10 }, (_, index) => {
//   //     const croreValue = (10 - index) * 10000000;
//   //     data.push({ label: `${10 - index} Cr`, value: croreValue }); // Store croreValue in data array
//   //     return `${10 - index} Cr`;
//   // }),
//   // ...Array.from({ length: 18 }, (_, index) => {
//   //     const lacValue = (95 - index * 5) * 100000;
//   //     data.push({ label: `${95 - index * 5} lac`, value: lacValue }); // Store lakhValue in data array
//   //     return `${95 - index * 5} lac`;
//   // }),
//   // ];

//   // // filter sum assured data based on annual income
//   // const filteredData = data.filter((item) => item.value <= (annualInc * 20));

//   return (
//     <div className="filter">
//       <label htmlFor="dropdown" className="labIcon">
//         Filters{' '}
//         <span>
//           <img style={{ paddingLeft: '2px' }} src={vector} alt="ram" />
//         </span>
//       </label>
//       <div className="dataDown">
//         <Dropdown
//           options={coverTillAge}
//           label={'Cover Till Age'}
//           className="custom-dropdown"
//           onChange={(e) => {
//             setLifeFilter({ ...lifeFilter, coverTillAge: e.target.value });
//           }}
//           value={combinedRedux.coverTillAge}
//           others={'coverTillAge'}
//           cta={'cta'}
//         />

//         <Dropdown
//           options={premiumPaymentOptions}
//           label={'Payment Option'}
//           className="custom-dropdown"
//           value={combinedRedux.PremiumPaymentOption}
//           onChange={(e) => {
//             setLifeFilter({
//               ...lifeFilter,
//               PremiumPaymentOption: e.target.value,
//             });
//           }}
//         />

//         <CustomInputBox
//           onChange={handlePpt}
//           onBlur={handlePpt}
//           label={'PPT'}
//           placeholder={'Enter PPT'}
//           value={ppt ? ppt : policyTermData}
//           validationType={'ppt'}
//           policyTerm={policyTermData}
//         />

//         <Dropdown
//           options={payModeOptions}
//           label={'Mode Of Payment'}
//           onChange={(e) => {
//             if (e.target.value !== 'Select') {
//               setModeOfPayment(e.target.value);
//               setLifeFilter({ ...lifeFilter, modeOfPayment: e.target.value });
//             }
//           }}
//           className="custom-dropdown"
//           value={combinedRedux.modeOfPayment}
//         />

//         {/* <Dropdown
//         options={filteredData.map((option) => option.label)}
//         label={'Sum Assured'}
//         onChange={(e) => {
//             if (e.target.value !== 'Select') {
//             setSumAssured(e.target.value);
//             setLifeFilter({ ...lifeFilter, sumAssured: e.target.value });
//             }
//         }}
//         className="custom-dropdown"
//         value={Object.keys(sumAssuredData).find((key) => sumAssuredData[key] === combinedRedux.sumAssured)}
//         /> */}
//         <CustomInputBox
//           label={`SA (${formatSumAssured(combinedRedux.sumAssured)})`}
//           placeholder={'Enter Sum Assured'}
//           sum={true}
//           value={combinedRedux.sumAssured}
//           onChange={handleSumAssured}
//         />

//         <Dropdown
//           options={deathBenefits}
//           label={'Death Benefit Payout'}
//           onChange={(e) => {
//             if (e.target.value !== 'death Benefit') {
//               setDeathBenefit(e.target.value);
//               setLifeFilter({
//                 ...lifeFilter,
//                 DeathBenefitOption: e.target.value,
//               });
//             }
//           }}
//           className="custom-dropdown"
//           value={combinedRedux.DeathBenefitOption}
//           more={deathTooltip}
//         />

//         {/* {
//           combinedRedux.DeathBenefitOption === 'Lump-Sum-Income' ? (
//             <CustomInputBox
//                 onChange= { handleLumpSumPersent}
//                 onBlur = {handleLumpSumPersent}
//                 label={'Lumpsum Percent'}
//                 placeholder={'Enter'}
//                 value={lumpSumPersent ? lumpSumPersent : combinedRedux.LumpsumPercentage}
//             />
//           ) : null
//         } */}

//         {payoutAllowedOptions.includes(combinedRedux.DeathBenefitOption) ? (
//           <Dropdown
//             options={payoutTermData}
//             label={'Payout Term / Lump-Sum %'}
//             onChange={(e) => {
//               setLifeFilter({ ...lifeFilter, PayoutTerm: e.target.value });
//             }}
//             className="custom-dropdown"
//             value={combinedRedux.PayoutTerm}
//             more={payoutTooltip}
//           />
//         ) : null}
//       </div>
//       {/* 2nd Side of the filter */}
//       <div>
//         {/* <div className="checkdiv">
//         <input
//         type="checkbox"
//         id="apiCheckbox"
//         className="check"
//         checked={isCheckedMenu}
//         onChange={handleCheckboxChange}
//         style={{ backgroundColor: isCheckedMenu ? 'yellow' : 'initial' }}
//       />
//         <label for="apiCheckbox" className="checkText">Insurance Plans with Premium Return</label>
//       </div> */}
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { lifeEnquiryAPI, updateFirstPageData } from '../../Redux/LifeRedux';
import vector from '../../assets/Vector.png';
import './filter.css';
import { getAgeOptions } from '../../utilities/dobToCoverTillAge';
import formatSumAssured from '../../utilities/calculateSum';
import { calculateAge } from '../../utilities/calculateAge';
import { FcInfo } from 'react-icons/fc';
import { Tooltip } from 'antd';

export const FilterBar = ({
  CallQuoteAPIs,
  isCheckedMenu,
  handleCheckboxChange,
  slugData,
}) => {
  const combinedRedux = useSelector((state) => state.life.combinedRedux);
  console.log('🚀 ~ combinedRedux:', combinedRedux);
  const dispatch = useDispatch();

  const Age = calculateAge(combinedRedux?.userDetail?.dob);
  const policyData = combinedRedux.coverTillAge - Age;
  const policyTermData = combinedRedux.policyTerm
    ? combinedRedux.policyTerm
    : policyData;

  // Local state to track all filter values
  const [lifeFilter, setLifeFilter] = useState({
    coverTillAge: combinedRedux.coverTillAge || '',
    PremiumPaymentOption: combinedRedux.PremiumPaymentOption || '',
    premiumPaymentTerm: combinedRedux.premiumPaymentTerm || '',
    modeOfPayment: combinedRedux.modeOfPayment || '',
    sumAssured: combinedRedux.sumAssured || '',
    DeathBenefitOption: combinedRedux.DeathBenefitOption || '',
    PayoutTerm: combinedRedux.PayoutTerm || '',
  });

  useEffect(() => {
    // When combinedRedux changes, update lifeFilter state
    if (combinedRedux) {
      setLifeFilter({
        coverTillAge: combinedRedux.coverTillAge || '',
        PremiumPaymentOption: combinedRedux.PremiumPaymentOption || '',
        premiumPaymentTerm: combinedRedux.premiumPaymentTerm || '',
        modeOfPayment: combinedRedux.modeOfPayment || '',
        sumAssured: combinedRedux.sumAssured || '',
        DeathBenefitOption: combinedRedux.DeathBenefitOption || '',
        PayoutTerm: combinedRedux.PayoutTerm || '',
      });
    }
  }, [
    combinedRedux.coverTillAge,
    combinedRedux.PremiumPaymentOption,
    combinedRedux.premiumPaymentTerm,
    combinedRedux.modeOfPayment,
    combinedRedux.sumAssured,
    combinedRedux.DeathBenefitOption,
    combinedRedux.PayoutTerm,
  ]);

  const premiumPaymentTermOptions = [
    'Select',
    ...Array.from({ length: 26 }, (_, i) => (i + 1).toString()),
  ];
  const payModeOptions = [
    'Select',
    'Yearly',
    'Half-Yearly',
    'Quarterly',
    'Monthly',
  ];
  const deathBenefits = [
    'Select',
    'Lump-Sum',
    'Income',
    'Increasing Income',
    'Lump-Sum-Income',
  ];
  const premiumPaymentOptions = [
    'Select',
    'Regular Pay',
    'Limited Pay',
    'Single Pay',
  ];
  const payoutTermData = ['Select', '5', '10', '20', '30', '40'];
  const payoutAllowedOptions = ['Income', 'Lump-Sum-Income'];

  // Tooltip texts for Death Benefit
  const deathTooltipText = {
    Income: 'Security benefit will be given on a yearly basis',
    'Lump-Sum':
      'Your maturity benefit on your death benefit will be given as a one-off payment.',
    payout:
      'This option is only allowed for Lump-Sum-Income or Income on ICICI IPS.',
  };

  const [coverTillAgeOptions, setCoverTillAgeOptions] = useState([]);

  useEffect(() => {
    if (combinedRedux?.userDetail?.dob) {
      const options = getAgeOptions(new Date(combinedRedux.userDetail.dob));
      setCoverTillAgeOptions(['Select', 'Whole Life', ...options]);
    }
  }, [combinedRedux?.userDetail?.dob]);

  const handlePpt = (value) => {
    if (value !== '') {
      let policyTerm = combinedRedux.policyTerm
        ? combinedRedux.policyTerm
        : policyTermData;
      if (Number(value) >= policyTerm) {
        setLifeFilter((prev) => ({
          ...prev,
          premiumPaymentTerm: policyTerm.toString(),
          PremiumPaymentOption: 'Regular Pay',
        }));
      } else if (Number(value) === 1) {
        setLifeFilter((prev) => ({
          ...prev,
          premiumPaymentTerm: value,
          PremiumPaymentOption: 'Single Pay',
        }));
      } else {
        setLifeFilter((prev) => ({
          ...prev,
          premiumPaymentTerm: value,
          PremiumPaymentOption: 'Limited Pay',
        }));
      }
    } else {
      // If empty input, clear premiumPaymentTerm but keep option unchanged
      setLifeFilter((prev) => ({
        ...prev,
        premiumPaymentTerm: '',
      }));
    }
  };

  // Matching handler for Payment Option to keep fields in sync
  const handlePaymentOption = (value) => {
    if (value !== '') {
      let policyTerm = combinedRedux.policyTerm
        ? combinedRedux.policyTerm
        : policyTermData;
      let pptVal = lifeFilter.premiumPaymentTerm;

      if (value === 'Regular Pay') {
        pptVal = policyTerm.toString();
      } else if (value === 'Single Pay') {
        pptVal = '1';
      } else if (value === 'Limited Pay') {
        // If ppt is invalid for Limited Pay, set fallback
        if (
          pptVal === '' ||
          Number(pptVal) >= policyTerm ||
          Number(pptVal) === 1
        ) {
          pptVal = (policyTerm - 1).toString();
        }
      }
      setLifeFilter((prev) => ({
        ...prev,
        PremiumPaymentOption: value,
        premiumPaymentTerm: pptVal,
      }));
    } else {
      // Clear Payment Option if empty
      setLifeFilter((prev) => ({
        ...prev,
        PremiumPaymentOption: '',
      }));
    }
  };

  // Handlers for other inputs (simplified)
  const handleInputChange = (field) => (e) => {
    const val = e.target.value;

    // Basic validation for numeric fields (ppt, sumAssured)
    if (field === 'premiumPaymentTerm') {
      // Allow empty, digits only, no leading zeros, max policyTerm
      if (val === '') {
        setLifeFilter((prev) => ({ ...prev, premiumPaymentTerm: '' }));
        return;
      }
      if (/^0\d+/.test(val)) return;
      if (!/^[0-9]+$/.test(val)) return;
      if (Number(val) > (combinedRedux.policyTerm || policyTermData)) return;

      // Use old handlePpt to sync Payment Option
      handlePpt(val);
      return;
    }

    if (field === 'sumAssured') {
      if (val === '') {
        setLifeFilter((prev) => ({ ...prev, sumAssured: '' }));
        return;
      }
      if (/^0\d+/.test(val)) return;
      if (!/^[0-9]+$/.test(val)) return;
      if (Number(val) > 1000000000) return;

      setLifeFilter((prev) => ({ ...prev, sumAssured: val }));
      return;
    }

    // Other fields update straightforwardly
    setLifeFilter((prev) => ({ ...prev, [field]: val }));
  };

  const handleSubmit = () => {
    // On submit, send entire lifeFilter state + enquiryId
    dispatch(
      updateFirstPageData({ ...lifeFilter, enquiryId: combinedRedux.enquiryId })
    )
      .then(() => {
        dispatch(lifeEnquiryAPI({ enquiryId: combinedRedux.enquiryId }));
        CallQuoteAPIs();
      })
      .catch(console.error);
  };

  // Tooltip helper for Death Benefit label
  const renderLabelWithTooltip = (label, tooltipKey) => {
    const tooltipText = deathTooltipText[tooltipKey];
    if (!tooltipText) return <label className="labelUpper">{label}</label>;

    return (
      <Tooltip title={tooltipText} color="#f3961e">
        <label className="labelUpper">
          {label} <FcInfo className="infoIcon" />
        </label>
      </Tooltip>
    );
  };

  // Render dropdown helper
  const renderDropdown = ({
    label,
    options,
    value,
    onChange,
    tooltipKey,
    otherLabel,
  }) => (
    <>
      {renderLabelWithTooltip(label, tooltipKey)}
      <select className="custom-dropdown" value={value} onChange={onChange}>
        {options.map((opt, idx) => {
          const displayText =
            otherLabel === 'coverTillAge' &&
            opt !== 'Whole Life' &&
            opt !== 'Select'
              ? `${opt} Years`
              : opt;
          return (
            <option
              key={opt + idx}
              value={opt}
              className={opt === 'Whole Life' ? 'button-option' : ''}
            >
              {displayText}
            </option>
          );
        })}
      </select>
    </>
  );

  return (
    <div className="filter">
      <label htmlFor="dropdown" className="labIcon">
        Filters{' '}
        <span>
          <img style={{ paddingLeft: '2px' }} src={vector} alt="icon" />
        </span>
      </label>
      <div className="dataDown">
        {renderDropdown({
          label: 'Cover Till Age',
          options: coverTillAgeOptions,
          value: lifeFilter.coverTillAge,
          onChange: handleInputChange('coverTillAge'),
          otherLabel: 'coverTillAge',
        })}

        {renderDropdown({
          label: 'Payment Option',
          options: premiumPaymentOptions,
          value: lifeFilter.PremiumPaymentOption,
          onChange: (e) => handlePaymentOption(e.target.value),
        })}

        <label className="labelUpper">PPT</label>
        <input
          type="text"
          className="custom-input"
          placeholder="Enter PPT"
          value={lifeFilter.premiumPaymentTerm}
          onChange={handleInputChange('premiumPaymentTerm')}
          maxLength={2}
          onKeyPress={(e) => {
            const charCode = e.which || e.keyCode;
            if (charCode === 13) return;
            const char = String.fromCharCode(charCode);
            if (!/^[0-9]+$/.test(char)) e.preventDefault();
          }}
        />

        {renderDropdown({
          label: 'Mode Of Payment',
          options: payModeOptions,
          value: lifeFilter.modeOfPayment,
          onChange: handleInputChange('modeOfPayment'),
        })}

        <label className="labelUpper">{`SA (${formatSumAssured(
          lifeFilter.sumAssured
        )})`}</label>
        <input
          type="text"
          className="inputBoxSum custom-input"
          placeholder="Enter Sum Assured"
          value={lifeFilter.sumAssured}
          onChange={handleInputChange('sumAssured')}
          maxLength={10}
          onKeyPress={(e) => {
            const charCode = e.which || e.keyCode;
            if (charCode === 13) return;
            const char = String.fromCharCode(charCode);
            if (!/^[0-9]+$/.test(char)) e.preventDefault();
          }}
        />

        {renderDropdown({
          label: 'Death Benefit Payout',
          options: deathBenefits,
          value: lifeFilter.DeathBenefitOption,
          onChange: handleInputChange('DeathBenefitOption'),
          tooltipKey: lifeFilter.DeathBenefitOption,
        })}

        {payoutAllowedOptions.includes(lifeFilter.DeathBenefitOption) &&
          renderDropdown({
            label: 'Payout Term / Lump-Sum %',
            options: payoutTermData,
            value: lifeFilter.PayoutTerm,
            onChange: handleInputChange('PayoutTerm'),
            tooltipKey: 'payout',
          })}
      </div>

      <button className="submit-filter" onClick={handleSubmit}>
        Apply Filters
      </button>
    </div>
  );
};
